import { SELECT_SLICE } from "./types";

export const selectSlice = slice => {
  return { type: SELECT_SLICE, slice };
};
